<template>
    <div>

<!-- Preview Button - Now inside the CodeRunner component -->
<div class="preview-button-container">
      <button @click="togglePreview" class="preview-button">Toggle Preview</button>
    </div>
      
      <!-- Inline Display (Right-Side Floating Output) -->
    <div :class="['output-area', { expanded: showRunPopup }]">
      <iframe ref="inlineOutputFrame" class="output-frame"></iframe>
    </div>
    </div>
  </template>
  
  <script>
import { Liquid } from 'liquidjs';
import appsData from "./apps.json";

export default {
  data() {
    return {
      simulatedNode: {
        // A simple list of fruits to be used in Liquid loops
        fruits: [
          { name: "Apple", color: "Red", price: "1.99" },
          { name: "Banana", color: "Yellow", price: "0.99" },
          { name: "Cherry", color: "Red", price: "2.99" }
        ],
        apps: appsData, // Directly assign the imported JSON

        // "funnel" will hold the array of funnel data for each staff member.
        funnel: this.generateFunnelData(),

        // Simulated Dashboard Data
        status: "Applicant",
        status_days: "15",
        bin: "At Committee",
        bin_days: "2",
        term: "Fall 2025",
        program: "Computer Science",
        major: "Software Engineering",
        staff_assigned: "Ford Prefect",
        advisor: "Deep Thought",
        fafsa: "Received: 25/26 - 02-01-2025",
        quality: "5 - High",
        last_interaction: "Email Sent: Join us on a Campus Tour!",
        date: "02-10",
        days: "6",
        ping_count: "3",
        call_date: "01-29",
        call_days: "18",
        sms_date: "02-05",
        sms_days: "11",
        email_date: "02-10",
        email_days: "6",
        ping_date: "02-12",
        ping_days: "4",
        hot_lead: "y",
        high_ping: "y",
        registered: "n",
        notes: "Applicant demonstrates exceptional problem-solving skills, quick adaptability, and an uncanny ability to navigate complex situations. Bold, fearless, adaptable, and willing to push buttons without reading the warning labels. Will either revolutionize software engineering or accidentally delete the laws of physics. Either way, it should be interesting. Highly recommended for admission."
      }
    };
  },
  props: {
    showRunPopup: {
      type: Boolean,
      required: true,
    },
    htmlCode: {
      type: String,
      required: true,
    },
    cssCode: {
      type: String,
      required: true,
    },
  },

  watch: {
  htmlCode() {
    this.updateIframeContent();
  },
  cssCode() {
    this.updateIframeContent();
  },
  showRunPopup(newVal) {
    if (newVal) {
      this.updateIframeContent();
    }
  },
},

  mounted() {
    // Update iframe when component is mounted
    this.updateIframeContent();
  },

  methods: {
    togglePreview() {
      this.$emit("update:showRunPopup", !this.showRunPopup);
    },

    // Mark the method as async so we can use await inside it.
    async updateIframeContent() {
      // Always use the inline iframe reference
      const iframeRef = this.$refs.inlineOutputFrame;

      if (!iframeRef) {
        console.error("Unable to access inline iframe ref.");
        return;
      }

      const output = iframeRef.contentDocument;
      if (!output) {
        console.error("Unable to access iframe contentDocument.");
        return;
      }

      // Create a new Liquid engine instance
      const engine = new Liquid();

      // Render the Liquid template in htmlCode with simulatedNode as context.
      let renderedHtml;
      try {
        renderedHtml = await engine.parseAndRender(this.htmlCode, this.simulatedNode);
      } catch (error) {
        console.error("Error rendering Liquid template:", error);
        // If there is an error processing the Liquid template, fall back to plain HTML.
        renderedHtml = this.htmlCode;
      }

      // Write the final content (CSS + rendered HTML) into the iframe.
      //console.log("Updating inline iframe with content.");
      output.open();
      output.write(`<style>${this.cssCode}</style>${renderedHtml}`);
      output.close();
    },

    // Helper function to generate a random integer between min and max (inclusive)
    randomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    // Generate the funnel data array using the same logic as your Google Sheet.
    generateFunnelData() {
      // Define staff and their inquiry range
      const staffData = [
        { name: 'Boba Fett', inqsRange: [2400, 2500] },
        { name: 'Ellen Ripley', inqsRange: [2400, 2500] },
        { name: 'Samus Aran', inqsRange: [2400, 2500] },
        { name: 'The Doctor', inqsRange: [2400, 2500] },
        { name: 'Zaphod Beeblebrox', inqsRange: [2200, 2800] }
      ];

      // Create an array of funnel rows using map
      return staffData.map(staff => {
        // Generate the inquiries (inqs) value
        const inqs = this.randomInt(staff.inqsRange[0], staff.inqsRange[1]);

        // For applications, we use a random percentage between 5% and 20% of inqs.
        const apps = Math.round(inqs * (this.randomInt(5, 20) / 100));

        // For each subsequent step, use a random percentage between 20% and 50%
        const complete = Math.round(apps * (this.randomInt(20, 50) / 100));
        const admit = Math.round(complete * (this.randomInt(20, 50) / 100));
        const deposit = Math.round(admit * (this.randomInt(20, 50) / 100));
        const enroll = Math.round(deposit * (this.randomInt(20, 50) / 100));

        // Return an object with the funnel data for this staff member.
        return {
          value: staff.name,
          inqs: inqs,
          apps: apps,
          complete: complete,
          admit: admit,
          deposit: deposit,
          enroll: enroll
        };
      });
    }
  }
};
</script>
  
  <style scoped>
  /****** Updated Output Area Styles ******/
.output-area {
  position: fixed;
  top: 50px; /* Adjust based on your header height */
  right: 0;
  width: 20%;
  height: calc(100vh - 80px); /* Just above bottom */
  border: 1px solid #333;
  border-radius: 15px;
  background-color: white;
  transition: width 0.3s ease-in-out;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  clip-path: inset(0 0 0 0px); /* Ensures the left edge is always visible */
}

/* Expanded state */
.output-area.expanded {
  width: calc(100vw - 20px); /* Expands to almost full width */
  top: 50px; /* Ensures it stays below the header */
  right: 0;
  z-index: 1000;
  border-radius: 15px; /* Keep all corners rounded even in expanded mode */
  clip-path: inset(0 0 0 0px); /* Maintains 10px padding on the left */
}



/* Adjust inline iframe */
.output-frame {
  width: 100%;
  height: 100%;
  border: none;
}

/****** Preview Button Styles ******/
.preview-button-container {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1100;
}

.preview-button {
  writing-mode: vertical-rl; /* Rotate text vertically */
  transform: rotate(180deg);
  padding: 10px;
  font-size: 16px;
  background: #00669e;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.3s;
}

.preview-button:hover {
  background: #01395c;
}

  </style>
  